<template>
  <div class="c">
    <!-- 学科选择 -->
    <div class="knowledge-subject">
        <span class="subject-type">所属科目:</span>
        <span v-for="(item,i) in questionType" :key="i"
        :class="[{'active':item.subject_id===questionNumber},'subject-item']"
        @click="onChangeList(item)"
        >{{item.subject_name}}</span>
      </div>
    <!-- 年级搜索 -->
    <div class="c-search">
      <!-- <div>
        <span class="c-search__grade">课程:</span>
        <el-select v-model="searchForm.course" value-key="id" placeholder="请选择"
        @change="courseChange">
          <el-option
            v-for="item in courseList"
            :key="item.id"
            :label="item.course_name"
            :value="item.course_id">
          </el-option>
        </el-select>
      </div> -->
      <!-- <div> 本次迭代不要
        <span class="c-search__grade">课次:</span>
        <el-select v-model="searchForm.lesson" value-key="id" placeholder="请选择">
          <el-option
            v-for="item in lessonsList"
            :key="item.id"
            :label="item.name"
            :value="item.name">
          </el-option>
        </el-select>
      </div> -->
      <!-- <el-date-picker
        popper-class="picker-ppp"
        @change="pickChange"
        v-model="dateRange"
        type="daterange"
        unlink-panels
        range-separator="至"
        :default-value="Date.now() - 29 * 24 * 3600 * 1000"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="pickerOptions"
        >
      </el-date-picker> -->
      <div class="week-picker-wrapper">
        <el-date-picker
          ref="weekPicker"
          popper-class="picker-ppp"
          @change="pickChange"
          v-model="dateRange"
          type="week"
          value-format="yyyy-MM-dd"
          range-separator="至"
          :default-value="Date.now() - 29 * 24 * 3600 * 1000"
          :picker-options="pickerOptions"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          class="week-picker-input"
          >
        </el-date-picker>
        <div class="week-picker-display" @click="openWeekPicker">
          <i class="el-icon-date"></i>
          <span>{{ weekDisplayText }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { getSubjectCourseList } from '@/api/pt';
import { unlocking } from '@/utils/access-control';

export default {
  name: 'SearchCriteria',
  props: {
    gradeId: {
      require: true,
    },
    classId: {
      require: true,
    },
    masterClassId: {
      require: true,
      default: 0,
    },
  },
  computed: {
    weekDisplayText() {
      if (!this.dateRange) {
        return '请选择日期';
      }
      let selectedDate;
      if (Array.isArray(this.dateRange)) {
        if (this.dateRange.length < 1) {
          return '请选择日期';
        }
        const [firstDate] = this.dateRange;
        selectedDate = firstDate;
      } else {
        selectedDate = this.dateRange;
      }
      const [weekStart, weekEnd] = this.getAlignedWeekRange(selectedDate);
      return `${weekStart.format('YYYY-MM-DD')} 至 ${weekEnd.format('YYYY-MM-DD')}`;
    },
  },
  data() {
    return {
      questionType: [],
      pickerMinDate: '',
      questionNumber: 0,
      searchForm: {
        course: '',
        lesson: '',
      },
      courseList: [],
      dateRange: (() => {
        const today = dayjs();
        const day = today.day();
        const monday = day === 0 ? today.subtract(6, 'day') : today.subtract(day - 1, 'day');
        return monday.toDate();
      })(),
      pickerOptions: {
        firstDayOfWeek: 1,
        // onPick: ({ maxDate, minDate }) => {
        //   this.pickerMinDate = minDate.getTime();
        //   if (maxDate) {
        //     this.pickerMinDate = '';
        //   }
        // },
        // disabledDate: (time) => {
        //   if (this.pickerMinDate !== '') {
        //     const day30 = (30 - 1) * 24 * 3600 * 1000;
        //     let maxTime = this.pickerMinDate + day30;
        //     if (maxTime > new Date()) {
        //       maxTime = new Date();
        //       return time.getTime() > maxTime || time.getTime() < this.pickerMinDate - day30;
        //     }
        //     return maxTime < time.getTime() || time.getTime() < this.pickerMinDate - day30;
        //   }
        //   return time.getTime() > Date.now();
        // },

      },
    };
  },
  mounted() {
    this.pickChange();
    this.getSubjectCourseList();
  },
  watch: {
    classId() {
      this.courseList = [];
      this.searchForm.course = '';
      this.getSubjectCourseList();
    },
  },
  methods: {
    getAlignedWeekRange(date) {
      const target = dayjs(date);
      const day = target.day();
      const monday = day === 0 ? target.subtract(6, 'day') : target.subtract(day - 1, 'day');
      const sunday = monday.add(6, 'day');
      return [monday, sunday];
    },
    onChangeList(item) { // 切换
      this.courseList = [];
      this.searchForm.course = '';
      this.questionNumber = item.subject_id;
      this.getSubjectCourseList(item.crm_subject_id);
      this.$emit('subjectChange', this.questionNumber);
    },
    getSubjectCourseList(value) { // 学科列表和课程列表请求
      getSubjectCourseList({
        class_id: this.classId,
        subject_id: value || '',
        grade_id: this.gradeId,
        school_master_class_id: this.masterClassId,
        is_charge: unlocking('Master_Sale_Manager') ? 1 : 0,
        is_filter: 0,
      }).then((res) => {
        this.questionType = res.data.subject_list;
        this.courseList = res.data.course_list.filter((kitem) => Number(kitem.course_id) !== 0);
      }).catch((err) => {
        console.log(err);
      });
    },
    pickChange() { // 切换时间
      if (!this.dateRange) {
        return;
      }
      let selectedDate;
      // type="week" 时，dateRange 可能是单个日期对象或数组
      if (Array.isArray(this.dateRange)) {
        if (this.dateRange.length < 1) {
          return;
        }
        const [firstDate] = this.dateRange;
        selectedDate = firstDate;
      } else {
        selectedDate = this.dateRange;
      }
      // 计算该周的周一和周日
      const [weekStart, weekEnd] = this.getAlignedWeekRange(selectedDate);
      // 更新 dateRange：type="week" 时保持为单个日期对象（周一）
      this.dateRange = weekStart.toDate();
      // 发送事件
      const startDate = weekStart.format('YYYY-MM-DD');
      const endDate = weekEnd.format('YYYY-MM-DD');
      this.$emit('timeChange', { startDate, endDate });
    },
    // 打开日期选择器
    openWeekPicker() {
      if (!this.$refs.weekPicker) {
        return;
      }
      // 通过点击输入框来打开选择器
      const input = this.$refs.weekPicker.$el.querySelector('input');
      if (input) {
        input.click();
        return;
      }
      // 如果找不到输入框，尝试直接设置 visible
      if (this.$refs.weekPicker.pickerVisible !== undefined) {
        this.$refs.weekPicker.pickerVisible = true;
      }
    },
    courseChange(val) {
      console.log(val);
      this.$emit('courseChange', val);
    },
  },
};
</script>

<style lang="scss" scoped>
 .c {
    background: #FFFFFF;
    margin-bottom: 60px;
    border-radius: 2px;
    &-strong {
      width: 74px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      text-align: start;
      color: #000000;
    }
    .active {
      color: #1989FA;
    }
    .knowledge-subject{
      height: 87px;
      width: 100%;
      line-height: 87px;
      .subject-type{
        font-size: 16px;
        color: #000000;
        margin-right:30px ;
      }
      .subject-item:last-child{
        font-size: 14px;
        color: #303133;
      }
      .subject-item:not(:last-child){
        font-size: 14px;
        color: #303133;
        display: inline-block;
        margin-right:52px ;
        position: relative;
        &::before{
          content: '';
          width: 4px;
          height: 4px;
          background: #C0C4CC;
          border-radius: 50%;
          left: 50px;
          top: 42px;
          position: absolute;
        }
      }
      .active{
          color: #1989FA !important;
      }
    }
    &-text {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #303133;
    }
    &-dot {
      &:before {
        position: relative;
        display: inline-block;
        top: -2px;
        left: -12px;
        content: '';
        width: 4px;
        height: 4px;
        background: #C0C4CC;
        border-radius: 50%;
      }
    }
    &-search {
      display: flex;
      // padding: 0 12px;
      /deep/ .el-select {
        margin-right: 40px;
      }
      /deep/ .el-date-editor {
        margin-left: auto;
      }
      &__grade {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #000000;
        line-height: 16px;
        margin-right: 12px;
      }
      .week-picker-wrapper {
        position: relative;
        display: inline-block;
        .week-picker-input {
          /deep/ .el-input__inner {
            opacity: 0;
            position: absolute;
            z-index: 1;
            cursor: pointer;
          }
        }
        .week-picker-display {
          position: absolute;
          left: 0;
          top: 0;
          width: 240px;
          height: 40px;
          line-height: 40px;
          padding: 0 15px 0 30px;
          border: 1px solid #DCDFE6;
          border-radius: 4px;
          background-color: #fff;
          cursor: pointer;
          font-size: 14px;
          color: #606266;
          box-sizing: border-box;
          z-index: 0;
          display: flex;
          align-items: center;
          &:hover {
            border-color: #C0C4CC;
          }
          .el-icon-date {
            position: absolute;
            left: 10px;
            font-size: 16px;
            color: #C0C4CC;
            pointer-events: none;
          }
          span {
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
  }
</style>
